import { add, format } from 'date-fns'

export const MUTE_PERIODS = ['1 week', '2 weken', '1 maand', '3 maanden', '1 jaar']

export const INACTIVE_TICKET_STATUSES = ['approved', 'cancelled']

const muteDurations: { [period: string]: object } = {
  '1 week': { weeks: 1 },
  '2 weken': { weeks: 2 },
  '1 maand': { months: 1 },
  '3 maanden': { months: 3 },
  '1 jaar': { years: 1 },
}

// which case statuses allow which action; finish and cancel are additionally
// blocked by an active ticket, see hasBlockingTicket
export const caseActionAvailable = (action: string, caseStatus: string) => {
  if (action === 'open') return ['created', 'muted', 'finished'].includes(caseStatus)
  if (action === 'mute') return !['muted', 'finished'].includes(caseStatus)
  return ['created', 'open'].includes(caseStatus)
}

export const hasBlockingTicket = (tickets: Array<{ status: string }>) =>
  tickets.some((ticket) => !INACTIVE_TICKET_STATUSES.includes(ticket.status))

// the PUT /cases/{id} payload for a case status action
export const caseActionPayload = (action: string, caseStatus: string, period = '1 week') => {
  if (action === 'cancel') return { cancelled_at: new Date() }
  if (action === 'finish') return { finished_at: new Date() }
  if (action === 'mute') {
    return { muted_till: format(add(new Date(), muteDurations[period]), 'yyyy-MM-dd') }
  }
  if (action === 'open') {
    if (caseStatus === 'muted') {
      return {
        muted_till: format(add(new Date(), { days: -1 }), 'yyyy-MM-dd'),
        opened_at: new Date(),
      }
    }
    return { opened_at: new Date() }
  }
  return null
}
